@if (isWebphoneMode) {
  @if (useCubeSdk) {
    <iframe
      id="webphoneFrame"
      src="https://quickdialer.in/moneytorconnWebphone"
      allow="microphone"
      class="cube-sdk-audio-frame"
      [class.cube-sdk-audio-frame--offscreen]="!iframeVisible"
      [class.cube-visible-iframe]="iframeVisible"
      (load)="onWebphoneFrameLoad()"
      title="Webphone">
    </iframe>
  }
  <div
    class="cube-webphone-bridge"
    [class.cube-webphone-bridge--hidden]="!iframeVisible"
    [class.cube-webphone-bridge--visible]="iframeVisible"
    [class.sdk-debug]="sdkDebug"
    [class.minimized]="isMinimized && isLoggedIn"
    [style.transform]="iframeVisible ? getTransform() : null">
    @if (iframeVisible) {
      <div class="cube-webphone-header" (mousedown)="onMouseDown($event)">
        <span class="cube-title">{{ sdkDebug ? 'Cube SDK debug (index2)' : 'Cube Webphone' }}</span>
        <div class="cube-controls">
          <span class="cube-status" [class.connected]="isLoggedIn">{{ statusText }}</span>
          <button class="control-btn" type="button" (click)="toggleMinimize()" [title]="isMinimized ? 'Expand' : 'Collapse'">
            @if (!isMinimized) {
              <mat-icon>expand_more</mat-icon>
            }
            @if (isMinimized) {
              <mat-icon>expand_less</mat-icon>
            }
          </button>
        </div>
      </div>
    }
    @if (sdkDebug && iframeVisible && !isMinimized) {
      <div class="sdk-debug-grid">
        <div class="sdk-debug-panel">
          <label>Agent ID</label>
          <input [(ngModel)]="agentId" autocomplete="off">
          <label>Extension</label>
          <input [(ngModel)]="extension" autocomplete="off">
          <label>Password</label>
          <input [(ngModel)]="password" type="password" autocomplete="off">
          <label>Campaign ID</label>
          <input [(ngModel)]="campaignId" autocomplete="off">
          <label>Phone Number</label>
          <input [(ngModel)]="phone" placeholder="98999xxxxx">
          <div class="sdk-debug-btns">
            <button type="button" class="primary" (click)="debugInit()">Initialize</button>
            <button type="button" class="primary" (click)="debugLogin()">Login</button>
            <button type="button" (click)="debugLogout()">Logout</button>
          </div>
          <div class="sdk-debug-btns">
            <button type="button" class="primary" (click)="debugCall()">Make Call</button>
            <button type="button" (click)="debugAnswer()">Answer</button>
            <button type="button" class="danger" (click)="debugHangup()">Hangup</button>
          </div>
          <div class="sdk-debug-btns">
            <button type="button" (click)="debugHold()">Hold</button>
            <button type="button" (click)="debugUnhold()">Unhold</button>
            <button type="button" (click)="debugMute()">Mute</button>
            <button type="button" (click)="debugUnmute()">Unmute</button>
          </div>
          <div class="sdk-debug-btns">
            <button type="button" (click)="debugTransfer()">Transfer</button>
            <button type="button" (click)="debugRedirect()">Redirect</button>
            <button type="button" class="break" (click)="debugBreakStart()">Lunch Break</button>
            <button type="button" (click)="debugBreakEnd()">Break End</button>
            <button type="button" class="dispose" (click)="debugDispose()">Dispose</button>
          </div>
          <pre class="sdk-debug-log">{{ debugLog }}</pre>
        </div>
      </div>
    }
    @if (iframeUrl && !useCubeSdk) {
      <iframe
        #cubeWebphoneFrame
        id="cubeWebphoneFrame"
        [src]="iframeUrl"
        frameborder="0"
        allow="microphone *; camera *; autoplay *"
        [class.cube-hidden-iframe]="!iframeVisible"
        [class.cube-visible-iframe]="iframeVisible && (!isMinimized || !isLoggedIn)"
        class="cube-visible-iframe--interactive"
        (load)="onWebphoneFrameLoad()"
        title="Cube Webphone">
      </iframe>
    }
  </div>
}

@if (!isWebphoneMode) {
  <div
    class="cube-iframe-container"
    [class.minimized]="isMinimized"
    [class.popup-mode]="isPopupMode"
    [style.transform]="getTransform()">
    <div class="cube-header" (mousedown)="onMouseDown($event)">
      <span class="cube-title">QuickCall Agent</span>
      <div class="cube-controls">
        <span class="cube-status" [class.connected]="isLoggedIn">{{ statusText }}</span>
        <button class="control-btn" type="button" (click)="toggleMinimize()" [title]="isMinimized ? 'Expand' : 'Collapse'">
          @if (!isMinimized) {
            <mat-icon>expand_more</mat-icon>
          }
          @if (isMinimized) {
            <mat-icon>expand_less</mat-icon>
          }
        </button>
      </div>
    </div>
    @if (!isMinimized) {
      <div class="cube-iframe-wrapper">
        @if (iframeUrl) {
          <iframe
            #cubeWebphoneFrame
            id="cubeWebphoneFrame"
            [src]="iframeUrl"
            frameborder="0"
            allow="microphone *; camera *; autoplay *"
            class="cube-iframe">
          </iframe>
        }
      </div>
    }
  </div>
}
